import React from "react";

const SchoolStatus = ({ status, isDeleted }) => {
  return (
    <div className="font-rajdhani">
      {status === true && isDeleted === false && (
        <div className="status-active status-width">
          {status === true && isDeleted === false && (
            <span className="">Active </span>
          )}
        </div>
      )}
      {status === false && isDeleted === false && (
        <div className="status-warning status-width">
          {status === false && isDeleted === false && (
            <span className="">Inactive </span>
          )}
        </div>
      )}
      {isDeleted === true && (
        <div className="status status-width">
          {isDeleted === true && <span className="">Deleted</span>}
        </div>
      )}
    </div>
  );
};

export default SchoolStatus;
